import { render, staticRenderFns } from "./ControlloAlloggiOspitiView.vue?vue&type=template&id=36ff51ea&"
import script from "./ControlloAlloggiOspitiView.vue?vue&type=script&lang=ts&"
export * from "./ControlloAlloggiOspitiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports